import axios from "axios";

const RAW_BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const BACKEND_ORIGIN = RAW_BACKEND.replace(/\/+$/, "");
export const API = `${BACKEND_ORIGIN}/api`;

/**
 * Resolve a browser-fetchable absolute URL for a backend-relative photo path.
 * Backend returns values like `/api/technicians/{id}/photo` — this helper
 * prefixes the backend origin (never doubles `/api`). Falsy → empty string
 * so callers can conditionally render an initials fallback.
 */
export function resolveApiUrl(path) {
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;          // already absolute
  if (path.startsWith("/")) return `${BACKEND_ORIGIN}${path}`; // site-relative
  return `${API}/${path.replace(/^\/+/, "")}`;          // API-relative fallback
}

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("idea_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export default client;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
